const EmailIcon = () => (
  <svg
    className="footer-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M18 4H2c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 2v.01L10 11 2 6.01V6h16zm0 10H2V8l8 5 8-5v8z" />
  </svg>
);

export default EmailIcon;
